import { DeviceMobileIcon, EnvelopeIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import { useOrderingStore } from "../../store/use-ordering-store";
import { formatPhoneNumber } from "../../utils/format-phone-number";

export const Header = () => {
  const { t } = useTranslation();
  const { personalDetails, verificationType } = useOrderingStore();

  if (!personalDetails) return null;

  switch (verificationType) {
    case "phone":
      return (
        <>
          <DeviceMobileIcon className="size-8" />
          <p className="font-semibold text-xl">
            {t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.ENTER_CODE_SENT_PHONE")}{" "}
            <span className="font-normal">{formatPhoneNumber(personalDetails.phone, personalDetails.dialCode)}</span>
          </p>
        </>
      );
    case "email":
      return (
        <>
          <EnvelopeIcon className="size-8" />
          <p className="font-semibold text-xl">
            {t("GROUP_ACTIONS_ORDERING.CODE_VALIDATION_FORM.ENTER_CODE_SENT_EMAIL")}{" "}
            <span className="font-normal">{personalDetails?.email || ""}</span>
          </p>
        </>
      );
    default:
      return null;
  }
};
